import { type Actor } from '@campai/lib-common/entities'
import { hasAnyAdminOrganizationAccess } from '@campai/lib-common/utils/organization'

import { appState } from '@/appState'

export const canReadCommunity = () =>
    hasAnyAdminOrganizationAccess(appState.user) || appState.hasSystemPermission('community.admin')

export const canCreateCommunityContent = () =>
    hasAnyAdminOrganizationAccess(appState.user) || appState.hasSystemPermission('community.admin')

export const canModerateCommunityContent = () => appState.hasSystemPermission('community.admin')

export const canDeleteCommunityContent = () => appState.hasSystemPermission('community.admin')

export const isOwnCommunityContent = (createdBy: Actor | string | null | undefined) => {
    if (!createdBy || (typeof createdBy !== 'string' && (createdBy.type !== 'user' || !createdBy.userId))) {
        return false
    }

    if (typeof createdBy === 'string') {
        return createdBy === appState.user.userId
    }

    return createdBy.type === 'user' && !!createdBy.userId && createdBy.userId === appState.user.userId
}
